import { Column, Index, OneToMany } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

@Index('idx_ordinal', ['ordinal'], {})
@Index('idx_is_closed_type', ['isClosedType'], {})
@Index('unique_name', ['name', 'deletedDate'], {
	unique: true,
})
@Entity('client_lifecycle_stage', {}, { label: 'Client Lifecycle Stage' })
export class ClientLifecycleStageEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 100 })
	public name!: string;

	@Column('int', { name: 'ordinal', unsigned: true, default: () => "'0'" })
	public ordinal!: number;

	@Column('tinyint', {
		name: 'is_closed_type',
		width: 1,
		default: () => "'0'",
	})
	public isClosedType!: boolean;

	@Column('varchar', { name: 'color', nullable: true, length: 20 })
	public color!: string | null;

	@OneToMany(() => ClientEntity, (client) => client.fkClientLifecycleStage, {})
	public clients!: Array<ClientEntity>;
}
